import { zodResolver } from '@hookform/resolvers/zod';
import { generalResolver } from './generalValidations';
const { z } = require('zod');

const date = z.union([
  z.number({ message: 'Invalid Format. YYYY-MM-DD Format.' }),
  z.string({ message: 'Invalid Format. YYYY-MM-DD Format.' }),
  z.date({ message: 'Invalid Format. YYYY-MM-DD Format.' }),
]);

export const resolver = zodResolver(
  z.object({
    providerName: z
      .string()
      .min(1, { message: 'Provider Name is required' })
      .max(100, { message: 'Must be 100 characters or fewer' }),
    planName: z
      .string({ message: 'Plan Name is required' })
      .min(1, { message: 'Plan Name is required' })
      .max(100, { message: 'Must be 100 characters or fewer' }),
    effectiveDate: date,
    effectiveDateEnd: date,
    policyNumber: z
      .string()
      .min(1, { message: 'Policy Number is required' })
      .max(100, { message: 'Must be 100 characters or fewer' }),
    groupNumber: z
      .string()
      .min(1, { message: 'Group Number is required' })
      .max(100, { message: 'Must be 100 characters or fewer' }),
    subscriberEmployer: z.optional(
      z.string().max(100, { message: 'Must be 100 characters or fewer' })
    ),
    subscriberAddress1: z.optional(z.string()),
    subscriberAddress2: z.optional(z.string()),
    subscriberCity: z.optional(z.string().max(100)),
    subscriberState: z.optional(z.string().max(100)),
    subscriberZipCode: z.optional(z.string().max(100)),
    urlFrontCard: z.union([
      z.string({ message: 'Invalid URL for Front Card' }),
      z
        .instanceof(File)
        .refine((file) => file.size > 0, { message: 'File is required' }),
    ]),
    urlBackCard: z.union([
      z.string({ message: 'Invalid URL for Back Card' }),
      z
        .instanceof(File)
        .refine((file) => file.size > 0, { message: 'File is required' }),
    ]),
    generalResult: generalResolver,
  })
);
